import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import ApiCalls from 'app/utils/apiCalls';

export function getAttendingVeterinariansQueryOptions() {
  return queryOptions({
    queryKey: [{ query: '/attending_veterinarians' }] as const,
    queryFn: async () => {
      return ApiCalls.getAttendingVeterinarians().then(
        (response) => response.data.attending_veterinarians
      );
    },
  });
}

export function useDeleteAttendingVeterinarianMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [{ query: '/attending_veterinarians', type: 'DELETE' }] as const,
    mutationFn: async (variables: { name: string }) => {
      await ApiCalls.deleteAttendingVeterinarian(variables.name);
    },
    onSuccess: (_data, { name }) => {
      queryClient.setQueryData(
        [{ query: '/attending_veterinarians' }],
        (attendingVeterinarians: string[]) =>
          attendingVeterinarians?.filter((entry) => entry !== name)
      );
      queryClient.invalidateQueries({ queryKey: [{ query: '/attending_veterinarians' }] });
    },
  });
}
